import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AchievementsListComponent } from './achievements-list/achievements-list.component';
import { AchievementsCreateComponent } from './achievements-create/achievements-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: AchievementsListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: AchievementsCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'achievements-create/:id',
        component: AchievementsCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AchievementsRoutingModule { }
